module.exports = __webpack_public_path__ + "img/6.eb3ef1df.png";